<div class="editable-input-container" [class.is-editing]="isEditing">
  <div
    class="input-wrapper"
    [class.invalid]="displayFormControl.invalid && displayFormControl.touched">
    <div class="input-section">
      <!-- Text Input -->
      <ng-container *ngIf="inputType === 'text'">
        <input
          #editableInput
          [formControl]="displayFormControl"
          [readonly]="!isEditing"
          [id]="id"
          [placeholder]="placeholder"
          class="form-control .no-spinners"
          [type]="textType"
          [attr.min]="textType === 'number' ? minNumber : null"
          [attr.max]="textType === 'number' ? maxNumber : null"
          [attr.minlength]="minLength"
          [attr.maxlength]="maxLength"
          (input)="
            textType === 'number' || minLength || maxLength
              ? enforceNumberConstraints($event)
              : null
          " />
      </ng-container>

      <!-- Number Input -->
      <ng-container *ngIf="inputType === 'number'">
        <input
          #editableInput
          [formControl]="displayFormControl"
          [readonly]="!isEditing"
          [id]="id"
          [placeholder]="placeholder"
          class="form-control .no-spinners"
          type="number"
          [attr.min]="minNumber"
          [attr.max]="maxNumber"
          [attr.minlength]="minLength"
          [attr.maxlength]="maxLength"
          (input)="enforceNumberConstraints($event)" />
      </ng-container>

      <!-- Date Picker with custom styling wrapper -->
      <ng-container *ngIf="inputType === 'date'">
        <div class="custom-date-wrapper" [class.editing-mode]="isEditing">
          <!-- Overlay div to block interaction when not in edit mode -->
          <div *ngIf="!isEditing" class="interaction-blocker"></div>
          <irembogov-irembo-date-picker
            [customformControl]="displayFormControl"
            [placeholder]="placeholder"
            [disabled]="!isEditing"
            [dateFormat]="dateFormat"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [delimeter]="delimiter"
            [addRemoveTimeMinDate]="addRemoveTimeMinDate"
            [addRemoveTimeMaxDate]="addRemoveTimeMaxDate"
            (selectedDateEvent)="onDateValueChange($event)">
          </irembogov-irembo-date-picker>
        </div>
      </ng-container>

      <!-- Dropdown with custom styling wrapper -->
      <ng-container *ngIf="inputType === 'dropdown'">
        <div class="custom-dropdown-wrapper" [class.editing-mode]="isEditing">
          <!-- Overlay div to block interaction when not in edit mode -->
          <div *ngIf="!isEditing" class="interaction-blocker"></div>

          <irembogov-select
            class="inside-editable-input"
            [labelForId]="id"
            [items]="items"
            [bindLabel]="bindLabel"
            [bindValue]="bindValue"
            [multiple]="multiple"
            [placeholder]="placeholder"
            [disabled]="!isEditing"
            [customFormControl]="displayFormControl"
            (itemSelected)="onDropdownValueChange($event)">
          </irembogov-select>
        </div>
      </ng-container>

      <!-- Time Picker with custom styling wrapper -->
      <ng-container *ngIf="inputType === 'time'">
        <div class="custom-dropdown-wrapper" [class.editing-mode]="isEditing">
          <!-- Overlay div to block interaction when not in edit mode -->
          <div *ngIf="!isEditing" class="interaction-blocker"></div>
          <irembogov-time-picker
            [customFormControl]="displayFormControl"
            [placeholder]="placeholder"
            (itemSelected)="onDropdownValueChange($event)">
          </irembogov-time-picker>
        </div>
      </ng-container>

      <div class="inner-actions">
        <ng-container *ngIf="isEditing">
          <button
            class="btn clear-btn"
            (click)="cancelEdit()"
            placement="top"
            container="body"
            ngbTooltip="{{ 'Discard changes' | translate }}">
            <i class="fa fa-times"></i>
          </button>
        </ng-container>
        <ng-container *ngIf="!isEditing && isEdited">
          <span class="edited-badge">
            {{ 'Edited' | translate }}
          </span>
          <!-- Make sure the reset button is always clickable -->
          <button
            class="btn reset-btn"
            (click)="resetToInitial()"
            placement="top"
            container="body"
            ngbTooltip="{{ 'Undo Changes' | translate }}"
            style="z-index: 20">
            <i class="fa fa-refresh"></i>
          </button>
        </ng-container>
      </div>
    </div>

    <div class="actions">
      <ng-container *ngIf="isEditing">
        <button
          class="action-btn save-btn"
          (click)="saveEdit()"
          [disabled]="displayFormControl.invalid">
          <i class="fa fa-check"></i>
          {{ 'Save' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="!isEditing">
        <button class="action-btn edit-btn" (click)="startEdit()">
          <i class="fa fa-edit"></i>
          {{ 'Edit' | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>

<div class="invalid-feedback d-block">
  <span *ngIf="customFormControl.errors?.['required']">
    {{ 'This field is required' | translate }}
  </span>
  <span *ngIf="customFormControl.errors?.['minNumber']">
    {{ 'Value must be at least' | translate }} {{ minNumber }}
  </span>
  <span *ngIf="customFormControl.errors?.['maxNumber']">
    {{ 'Value must not exceed' | translate }} {{ maxNumber }}
  </span>
  <span *ngIf="customFormControl.errors?.['minlength']">
    {{ 'Value must be at least' | translate }} {{ minLength }}
    {{ 'characters long' | translate }}
  </span>
  <span *ngIf="customFormControl.errors?.['maxlength']">
    {{ 'Value must not exceed' | translate }} {{ maxLength }}
    {{ 'characters' | translate }}
  </span>
  <span *ngIf="customFormControl.errors?.['pattern']">
    {{ 'Value does not match the required pattern' | translate }}
  </span>
</div>
